import React, { useContext, useCallback } from 'react';
import { ThemeProvider } from 'styled-components';
import { ThemeContext } from '..';
import { icons } from './icons';
import { ComplexIconProps } from './types';
import { SvgContainer } from './styles';

const ComplexIcon = ({
  id,
  name,
  size = 'medium',
  color = '#4d4d4d',
  onClick,
  disabled,
  clickable,
}: ComplexIconProps) => {
  const { actualTheme } = useContext(ThemeContext);
  const Icon = icons[name] || icons.destination;
  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      if (onClick && !disabled) {
        e.stopPropagation();
        onClick();
      }
    },
    [onClick, disabled],
  );

  return (
    <ThemeProvider theme={actualTheme}>
      <SvgContainer
        id={id}
        color={color}
        size={size}
        data-testid={id || 'icon-test-id'}
        onClick={handleClick}
        clickable={(typeof clickable === 'undefined' ? !!onClick : clickable) && !disabled}
        disabled={disabled}
      >
        <Icon
          height={actualTheme.complexIcon[size].size}
          width={actualTheme.complexIcon[size].size}
          viewBox="0 0 48 48"
        />
      </SvgContainer>
    </ThemeProvider>
  );
};

export default ComplexIcon;
